import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
  Alert,
} from "@mui/material";
import { useState } from "react";
import { addDocumentAttachment } from "../../api/documents";
import { fileToBase64 } from "../../utils/base64converter";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  open: boolean;
  onClose: () => void;
  companyId: string;
  documentId: string;
  onSuccess: () => void;
  existingFilenames: string[];
};

export default function AddAttachmentModal({
  open,
  onClose,
  companyId,
  documentId,
  onSuccess,
  existingFilenames,
}: Props) {
  const [file, setFile] = useState<File | null>(null);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { t } = useAppTranslation("common");

    const handleSubmit = async () => {
        if (!file) return;

        setError(null); 
        if (
            existingFilenames.some(
            (name) => name.toLowerCase() === file.name.toLowerCase()
            )
        ) {
            setError(t("Załącznik o takiej nazwie już istnieje."));
            return;
        }

        setLoading(true);

        try {
            const base64 = await fileToBase64(file);

            await addDocumentAttachment(companyId, documentId, {
            filename: file.name,
            description,
            fileBase64: base64,
            });

            onSuccess();
            onClose();
        } catch (e: any) {
            setError(
            e?.message ||
                t("Nie udało się dodać załącznika. Spróbuj ponownie.")
            );
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setError(null);
        setFile(null);
        setDescription("");
        onClose();
    };


  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("Dodaj załącznik")}</DialogTitle>

      <DialogContent>
        <Stack spacing={2} mt={1}>
            {error && (
            <Alert severity="error">
                {error}
            </Alert>
            )}

            <Button variant="outlined" component="label">
            {t("Wybierz plik")}
            <input
                type="file"
                hidden
                onChange={(e) =>
                setFile(e.target.files?.[0] ?? null)
                }
            />
            </Button>

            {file && (
            <Typography variant="body2">
                {file.name}
            </Typography>
            )}

            <TextField
            label={t("Opis")}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            />
        </Stack>
        </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>{t("Anuluj")}</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!file || loading}
        >
          {t("Dodaj")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
